import { render } from "./SliderDots.vue?vue&type=template&id=3f28019d&scoped=true"
import script from "./SliderDots.vue?vue&type=script&lang=js"
export * from "./SliderDots.vue?vue&type=script&lang=js"

import "./SliderDots.vue?vue&type=style&index=0&id=3f28019d&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f28019d"]])

export default __exports__